import { render, staticRenderFns } from "./DOCIcon.vue?vue&type=template&id=2db4c9dc"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db4c9dc')) {
      api.createRecord('2db4c9dc', component.options)
    } else {
      api.reload('2db4c9dc', component.options)
    }
    module.hot.accept("./DOCIcon.vue?vue&type=template&id=2db4c9dc", function () {
      api.rerender('2db4c9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/DOCIcon.vue"
export default component.exports